export default {
  'basicData': {
    'lastName': '梅花',
    'firstName': '花子',
    'lastNameFurigana': 'ばいか',
    'firstNameFurigana': 'はなこ',
    'birthYear': '2001',
    'birthMonth': '1',
    'birthDay': '1',
    'sex': '2',
    'age': '22',
    'postNumber': '5320027',
    'address1': '大阪府茨木市宿久庄2丁目19-5',
    'address2': '',
    'addressFurigana': 'おおさかふいばらきししゅくのしょう',
    'tel1': '090',
    'tel2': '****',
    'tel3': '****',
    'mobile': '',
    'fax': '',
    'email': '○○○○@baika.ac.jp',
    'idPhotoSrc': '',
    'useContact': [''],
    'contactPostNumber': '',
    'contactAddress1': '',
    'contactAddress2': '',
    'contactAddressFurigana': '',
    'contactCareOf': '',
    'contactTel': '',
    'contactMobile': '',
    'contactFax': '',
    'contactEmail': '',
    'updateDate': ''
  },
  'formatData': {
    'createDate': new Date(),
    'formatId': 'rirekisho',
    'saveName': 'rirekisho',
    'educationalHistories2': [],
    'educationalHistories': [
      {
        'year': '20**',
        'month': 3,
        'description': '梅花高等学校　卒業',
        'uuid': '4005e384-8ce0-405b-b0f1-dea47be1a4cb'
      },
      {
        'year': '20**',
        'month': 4,
        'description': '梅花女子大学　○○学部　○○学科　入学',
        'uuid': 'e193e07f-1cf2-4930-bd52-1065f88c2c4e'
      },
      {
        'year': '20**',
        'month': 3,
        'description': '梅花女子大学　○○学部　○○学科　卒業',
        'uuid': '108c84e3-ae50-40e7-90f5-0becc48785b4'
      }
    ],
    'jobHistories': [
      {
        'year': '2018',
        'month': '5',
        'description': '株式会社◯◯◯◯　入社',
        'uuid': '636850ef-d6c0-4c22-91b7-bc2508c76fe4'
      },
      {
        'year': '',
        'month': '',
        'description': '現在に至る',
        'uuid': '286a59ea-e324-40e5-a09d-eea79751ba54'
      }
    ],
    'licenseHistories': [
      {
        'year': '2013',
        'month': '4',
        'description': '実用英語技能検定3級合格',
        'uuid': 'a2e09439-2c36-4981-a643-2b0f7adab257'
      },
      {
        'year': '2014',
        'month': '6',
        'description': 'TOEIC公開テスト300点取得',
        'uuid': 'd6d648f8-30dd-4c09-9367-036416723c1c'
      }
    ],
    'commuteHours': '0',
    'commuteMinutes': '40',
    'commuteDescription': '自家用車',
    'facultyBaika': '文化表現学部',
    'departmentBaika': '国際英語学科',
    'spouseNumber': '0',
    'hasSpouse': false,
    'underDutyToSupport': false,
    'reason': '',
    'hobby': `・□□□□
・○○○○
・△△△△`,
    'license': `2024年3月　□□□□免許　所得見込み
2022年3月　○○○○資格　取得
2021年5月　△△△△　　　取得`,
    'request': '内定後速やかに転居可能',
    'updateDate': ''
  }
}